import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/static_prompt.json";
import fr from "@/locales/fr/puzzle-types/static_prompt.json";

export const STATIC_PROMPT_NS = "puzzle-types/static_prompt";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerStaticPromptTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", STATIC_PROMPT_NS))
    i18n.addResourceBundle("en", STATIC_PROMPT_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", STATIC_PROMPT_NS))
    i18n.addResourceBundle("fr", STATIC_PROMPT_NS, fr, true, true);
}
